webpackJsonp([193747675109532],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: linear-gradient(rgba(251, 251, 251,1),rgba(255, 255, 255,1));\n  padding: 20px;\n  margin: 0px 10px 20px;\n  border: 1px solid #eee;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  width: 100%;\n  max-width: 800px;\n  @media (max-width: 600px) {\n    max-width: 450px;\n  }\n'], ['\n  background: linear-gradient(rgba(251, 251, 251,1),rgba(255, 255, 255,1));\n  padding: 20px;\n  margin: 0px 10px 20px;\n  border: 1px solid #eee;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  width: 100%;\n  max-width: 800px;\n  @media (max-width: 600px) {\n    max-width: 450px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  width: 100%;\n  background: ', ';\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n'], ['\n  height: 100%;\n  width: 100%;\n  background: ', ';\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 200px;\n  height: 200px;\n  margin-right: 20px;\n  flex: 0 1 200px;\n  @media (max-width: 600px) {\n    width: 100%;\n    margin: 0 0 20px;\n  }\n'], ['\n  width: 200px;\n  height: 200px;\n  margin-right: 20px;\n  flex: 0 1 200px;\n  @media (max-width: 600px) {\n    width: 100%;\n    margin: 0 0 20px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 400;\n  color: rebeccapurple;\n  opacity: 0.8;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 400;\n  color: rebeccapurple;\n  opacity: 0.8;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.9;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.9;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	// import defaultImage from '../../images/stock-student.jpg';
	
	var People_Item = function People_Item(props) {
	  return _react2.default.createElement(
	    PersonCard,
	    null,
	    _react2.default.createElement(
	      FlexContainer,
	      null,
	      props.person.image && _react2.default.createElement(
	        ImageContainer,
	        null,
	        _react2.default.createElement(PersonImage, { src: props.person.image.file.url + '?w=500' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { flex: '1' } },
	        _react2.default.createElement(
	          PersonName,
	          null,
	          props.person.name
	        ),
	        _react2.default.createElement(
	          PersonPosition,
	          null,
	          props.person.position
	        ),
	        _react2.default.createElement(
	          PersonInstitution,
	          null,
	          props.person.institution,
	          ' (',
	          props.person.year,
	          ')'
	        ),
	        props.person.description && _react2.default.createElement(PersonDetails, {
	          dangerouslySetInnerHTML: { __html: marked(props.person.description.description, { sanitize: true }) } })
	      )
	    )
	  );
	};
	
	exports.default = People_Item;
	
	
	var PersonCard = _styledComponents2.default.div(_templateObject);
	
	var FlexContainer = _styledComponents2.default.div(_templateObject2);
	
	var PersonImage = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.src && 'url(' + props.src + ')';
	});
	
	var ImageContainer = _styledComponents2.default.div(_templateObject4);
	
	var PersonName = _styledComponents2.default.h2(_templateObject5);
	
	var PersonInstitution = _styledComponents2.default.p(_templateObject6);
	
	var PersonPosition = _styledComponents2.default.p(_templateObject7);
	//
	var PersonDetails = _styledComponents2.default.p(_templateObject8);
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n'], ['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionText = _styledComponents2.default.div(_templateObject, '' /* opacity: 0.9; */);
	
	exports.default = SectionText;
	module.exports = exports['default'];

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/amy.96cb79db.jpg";

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-around;\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-around;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 650px) {\n    flex-direction: column;\n    align-items: center;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 650px) {\n    flex-direction: column;\n    align-items: center;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: 300px;\n  width: 300px;\n  margin: 8px 20px 0 0;\n  background: ', ';\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  @media (max-width: 900px) {\n    margin: 8px 20px 0 0;\n    max-height: 300px;\n    width: 200px;\n  };\n  @media (max-width: 650px) {\n    width: 100%;\n    margin: 0 0 20px;\n  };\n'], ['\n  height: 300px;\n  width: 300px;\n  margin: 8px 20px 0 0;\n  background: ', ';\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  @media (max-width: 900px) {\n    margin: 8px 20px 0 0;\n    max-height: 300px;\n    width: 200px;\n  };\n  @media (max-width: 650px) {\n    width: 100%;\n    margin: 0 0 20px;\n  };\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _People_Item = __webpack_require__(199);
	
	var _People_Item2 = _interopRequireDefault(_People_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionText = __webpack_require__(45);
	
	var _SectionText2 = _interopRequireDefault(_SectionText);
	
	var _amy = __webpack_require__(447);
	
	var _amy2 = _interopRequireDefault(_amy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var PeoplePage = function PeoplePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { minHeight: '100vh' } },
	    _react2.default.createElement(
	      _Container2.default,
	      { people: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        { light: true },
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          { light: true },
	          'About Me'
	        ),
	        _react2.default.createElement(
	          FlexRow,
	          null,
	          _react2.default.createElement(AboutImage, { src: _amy2.default }),
	          _react2.default.createElement(_SectionText2.default, { style: { flex: '1' }, dangerouslySetInnerHTML: { __html: marked(data.allContentfulPage.edges[0].node.mainText.body.body, { sanitize: true }) }
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { grey: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          null,
	          'Former Students'
	        ),
	        _react2.default.createElement(
	          FlexContainer,
	          null,
	          data.allContentfulPage.edges[0].node.additionalItems && data.allContentfulPage.edges[0].node.additionalItems.map(function (item, i) {
	            return _react2.default.createElement(_People_Item2.default, { key: i, person: item });
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = PeoplePage;
	var query = exports.query = '** extracted graphql fragment **';
	
	var FlexContainer = _styledComponents2.default.div(_templateObject);
	
	var FlexRow = _styledComponents2.default.div(_templateObject2);
	
	var AboutImage = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.src && 'url(' + props.src + ')';
	});
	
	// const Container = styled.div`
	//   background-color: #eee;
	//   flex-direction: column;
	//   justify-content: center;
	//   padding: 40px 10px;
	//   min-height: 100vh;
	//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	// `;
	//
	// const InnerContainer = styled.div`
	//   max-width: 960px;
	//   margin: auto;
	//   padding: 20px;
	//   color: #333;
	// `;
	//
	// const SectionHeader = styled.h1`
	//   text-align: center;
	//   font-weight: 300;
	// `;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-people-js-0854949501b7dc8c06e4.js